// extracted by mini-css-extract-plugin
export default {"container":"Banner_container__GCK-g"};